import { pipe } from 'ramda';

import { IRootState } from '../../../../store/root.types';

const pathToClaimState = (state: IRootState) => state.recipient.claim;

export const getIsLoading = pipe(pathToClaimState, state => state.isLoading);

export const getIsClaimed = pipe(pathToClaimState, state => state.isClaimed);

export const getIsResubscribeModalVisible = pipe(pathToClaimState, state => state.showResubscribeModal);

export const getErrors = pipe(pathToClaimState, state => state.errors);

export const getRedirectUrl = pipe(pathToClaimState, state => state.redirectUrl);
